import React from "react";
import PropTypes from "prop-types";
import BaseVideoPlayerWithConnector from "../../Internals/BaseVideoPlayerWIthConnector";

const VideoPlayerWithConnector = ({
  videoContainerId,
  accountType,
  disableFullscreen,
  children,
  render,
  iframeId,
  iframeUrl,
  isNakedVideoPlayer,
  onConnector,
  teamId,
  type,
  liveId
}) => (
  <BaseVideoPlayerWithConnector
    children={children}
    accountType={accountType}
    disableFullscreen={disableFullscreen}
    iframeId={iframeId}
    render={render}
    srcId={type === "live" ? liveId : videoContainerId}
    iframeUrl={iframeUrl}
    isNakedVideoPlayer={isNakedVideoPlayer}
    type={type || "video"}
    onConnector={onConnector}
    teamId={teamId}
  />
);

VideoPlayerWithConnector.propTypes = {
  /** videoContainer id */
  videoContainerId: PropTypes.string.isRequired,
  /** accountType : operator/coach/player/tagger */
  accountType: PropTypes.string.isRequired
};

export default VideoPlayerWithConnector;
